module.exports = __webpack_public_path__ + "img/ie.16bd1441.svg";